export default "__VITE_ASSET__Dk1vtU76__"